<script>
import { connectedHealthService } from '@services/safehaven/ConnectedHealthService'
import DeleteConfirmationDialog from '@components/delete-confirmation-dialog.vue'

export default {
  components: {
    DeleteConfirmationDialog,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadIframe: false,
      loading: false,
      providerLoading: false,
      url: '',
      selected: [],
      orgName: '',
      providerList: [],
      userId: null,
      accessToken: '',
      openDeleteDialog: false,
      providerForDelete: null,
    }
  },
  computed: {
    dialogContent() {
      if (!this.providerForDelete) {
        return ''
      }
      return `Are you sure you want to remove ${this.providerForDelete.provider_name} from Connection Hub?`
    },
    showIframe() {
      if (this.isShow || this.loadIframe) {
        return true
      }
      return false
    },
  },
  mounted() {
    const userLogedData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.orgName = userLogedData.user.user_org_details[0].org_name
    this.userId = userLogedData.user.user_id
    this.getUserDetails()
  },
  methods: {
    connectToProvider() {
      this.loading = true
      this.loadIframe = true
      this.loading = false
    },

    async getUserDetails() {
      try {
        this.providerLoading = true
        const response = await connectedHealthService.get1UpHealthUserDetails(
          this.userId
        )
        if (response.status === 200 || response.status === 201) {
          this.accessToken = response.data.access_token
          this.url = `https://system-search.1up.health/search?access_token=${this.accessToken}`
          this.providerList = response.data.connected_providers
        }
        this.providerLoading = false
      } catch (error) {
        this.loading = false
        this.providerLoading = false
      }
    },
    async deleteProvider() {
      try {
        const paramObj = {
          user_id: this.userId,
          patient_id: this.providerForDelete?.oneup_patient_id,
          token: this.accessToken,
        }
        const response = await connectedHealthService.deleteConnectedProviders(
          paramObj
        )
        if (response.status === 204) {
          const pos = this.providerList.findIndex(
            (provider) =>
              provider?.oneup_patient_id ===
              this.providerForDelete?.oneup_patient_id
          )
          this.providerList.splice(pos, 1)
          this.getUserDetails()
        }
      } catch (error) {
        console.warn(error)
        this.loading = false
      }
      this.openDeleteDialog = false
    },
    confirmDeleteProvider(selectedProvider) {
      this.providerForDelete = selectedProvider
      this.openDeleteDialog = true
    },
    closeDeleteDialog(action) {
      if (action === 'yes') {
        this.deleteProvider()
      } else {
        this.itemToDelete = {
          document_list: [],
        }
      }
    },
  },
}
</script>

<template>
  <v-container :class="$style.listContainer">
    <div v-if="providerLoading" :class="$style.loaderStyle">
      <p :class="$style.loaderText">Connection in progress...</p>
      <div class="mr-2">
        <v-img
          width="30"
          :src="require('@assets/images/safehaven/refresh.gif')"
        ></v-img>
      </div>
    </div>
    <div
      v-for="provider in providerList"
      :key="provider.oneup_provider_id"
      class="d-flex flex-column"
    >
      <v-divider class="mt-5 pb-5"></v-divider>
      <div class="d-flex flex-row align-center">
        <div
          class="d-flex justify-space-between flex-grow-1 align-start align-sm-center"
        >
          <div
            class="d-flex flex-column flex-sm-row align-left align-sm-center"
          >
            <span :class="[$style.providerName, 'mb-2 mb-sm-0']">{{
              provider.provider_name
            }}</span>
            <div
              v-if="provider.is_active"
              :class="[$style.providerConnectionStatus, 'd-flex align-center']"
            >
              <v-icon class="mr-2" color="#84B25A" size="18">
                mdi-check-circle
              </v-icon>
              <span>connected</span>
            </div>
            <div
              v-else
              :class="[
                $style.providerConnectionErrorStatus,
                'd-flex align-center',
              ]"
            >
              <v-icon class="mr-2" color="#EF4444" size="18">
                mdi-alert-circle
              </v-icon>
              <span
                >Disconnected.
                <a class="font-weight-bold" @click="connectToProvider">
                  Reconnect Now
                </a>
              </span>
            </div>
          </div>
          <v-icon
            color="primary"
            class="mr-2"
            @click="confirmDeleteProvider(provider)"
          >
            mdi-delete
          </v-icon>
        </div>
      </div>
    </div>
    <v-divider v-if="providerList.length > 0" class="mt-5"></v-divider>

    <v-row :class="[showIframe && 'mt-8']">
      <iframe v-if="showIframe" :src="url" height="700" width="100%" />
    </v-row>

    <DeleteConfirmationDialog
      :dialog.sync="openDeleteDialog"
      :content="dialogContent"
      yes-text="Yes, remove"
      no-text="Don't remove"
      @closeDeleteDialog="closeDeleteDialog"
    ></DeleteConfirmationDialog>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.listContainer {
  padding: 0 !important;
}

.providerName {
  width: 249px;
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.providerConnectionStatus {
  font-size: 14px;
  font-weight: 400;
  color: #84b25a;
}

.providerConnectionErrorStatus {
  font-size: 14px;
  font-weight: 400;
  color: #ef4444;
}

.loaderStyle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  margin-top: 20px;
  margin-bottom: 0;
  border-top: 1px solid #0000001f;
  border-bottom: 1px solid #0000001f;
}

.loaderText {
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 700;
}
</style>
